import { render, staticRenderFns } from "./MonthlyTaxExportLog.vue?vue&type=template&id=63583c14"
import script from "./MonthlyTaxExportLog.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxExportLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports